import React, { useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Navigate } from 'react-router-dom';
import { LogoutSuccessSVG, CoverageSVG } from '../../img/GlobalSVG';
import Button from '../common/button';
import GenericButton from '../../../Components/GenericButton/GenericButton';

const SetupSuccess = ({ currentStep }) => {
  const [backtoLogin, setBackToLogin] = useState(false);
  const gobacktoLoginPage = () => {
    setBackToLogin(true);
  };

  if (backtoLogin) {
    return <Navigate to="/admin" push={true}></Navigate>;
  }

  return currentStep === 6 ? (
    <Container className="password-success-container text-center">
      <Row>
        <Col>
          <LogoutSuccessSVG.LogoutSuccessSVG />
        </Col>
      </Row>
      <Row>
        <Col>
          <div className="content-box">
            <h1 className="password-success-title">
              Your password has been <br /> successfully changed
            </h1>
            <p className="mb-0">
              Thank you for using Administrator Portal. Your secure session is
              now closed.
              <br />
              We recommend you to close the browser for your security.{' '}
            </p>
            <GenericButton
              onClick={gobacktoLoginPage}
              variant="primary"
              className="login-button d-flex mx-auto text-center "
            >
              LOGIN
            </GenericButton>
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <div className="did-you-know-container-box d-flex">
            <CoverageSVG.BulbSVG />
            <div className="content-box text-left">
              <h4>Did you know?</h4>
              <p>
                If you are physically tired, the best thing to do is exercise as
                it will give you more energy than sitting.
              </p>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  ) : null;
};

export default SetupSuccess;
